import { getCurrentInstance } from 'vue';

const useLocale = () => {
  const instance = getCurrentInstance()?.proxy;
  const t = (key: string, params?: any) =>
    // @ts-ignore
    instance.$t(key, params);

  return { t };
};

export default useLocale;
